/** @format */

/**
 * Reads locale from Keycloak JWT payloads (access and ID token).
 * Supports common claim names and ui_locales (space/comma-separated).
 */

const LOCALE_CLAIM_KEYS = ['locale', 'Locale', 'ui_locales', 'lang'];

function normalizeLocaleClaim(raw) {
  if (raw == null) return null;
  if (Array.isArray(raw)) {
    const first = raw.find(x => x != null && String(x).trim() !== '');
    return first != null ? String(first).trim() : null;
  }
  const s = String(raw).trim();
  return s || null;
}

function readLocaleFromPayload(payload) {
  if (!payload || typeof payload !== 'object') return null;
  for (const key of LOCALE_CLAIM_KEYS) {
    if (!(key in payload)) continue;
    const raw = payload[key];
    if (key === 'ui_locales' && typeof raw === 'string') {
      const first = raw.split(/[\s,]+/).find(Boolean);
      const n = normalizeLocaleClaim(first);
      if (n) return n;
      continue;
    }
    const n = normalizeLocaleClaim(raw);
    if (n) return n;
  }
  return null;
}

export function getLocaleFromKeycloakTokenParsed(tokenParsed) {
  return readLocaleFromPayload(tokenParsed);
}

export function getLocaleFromKeycloakClient(client) {
  if (!client) return null;
  const fromAccess = readLocaleFromPayload(client.tokenParsed);
  if (fromAccess) return fromAccess;
  return readLocaleFromPayload(client.idTokenParsed);
}
